import { api, BULK_PARTNERS_ASSIGN_MESSAGE, setConfig } from '../..';
import { mapEntityToApi } from './mapper';
import { mapToFormData, PropertyType } from '../../../common';

export const bulkAssignPartners = (data: PropertyType): Promise<PropertyType> =>
	api.post('/games/bulk-assign-partners', mapToFormData(mapEntityToApi(data)), setConfig(data)).then((res) => {
		return {
			message: BULK_PARTNERS_ASSIGN_MESSAGE,
			nonImportedGames: res.data.notImportedGames,
			importedGames: res.data.importedGames,
			data: res.data,
		};
	});
